import { loadInputImask } from './loadInputImask'

/**
 *
 * @param {HTMLInputElement} input
 */
export function loadPhoneIMask(input) {
  loadInputImask(input, {
    mask: '(000) 000-0000',
    lazy: true,
    overwrite: 'shift',
  })
}
